import { render, staticRenderFns } from "./shopee.vue?vue&type=template&id=a71e93ee&scoped=true&"
import script from "./shopee.vue?vue&type=script&lang=js&"
export * from "./shopee.vue?vue&type=script&lang=js&"
import style0 from "./shopee.vue?vue&type=style&index=0&id=a71e93ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71e93ee",
  null
  
)

export default component.exports